import { render, staticRenderFns } from "./configPage.vue?vue&type=template&id=e6f08a0e&scoped=true"
import script from "./configPage.vue?vue&type=script&lang=js"
export * from "./configPage.vue?vue&type=script&lang=js"
import style0 from "./configPage.vue?vue&type=style&index=0&id=e6f08a0e&prod&lang=scss&scoped=true"
import style1 from "./configPage.vue?vue&type=style&index=1&id=e6f08a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f08a0e",
  null
  
)

export default component.exports